export default __webpack_public_path__ + "static/media/phinestsFooter.29d8ef45.png";